import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomgridModule } from '../customgrid';
import { ModalModule } from '../modal';
import { ReportingComponent } from './reporting.component';


@NgModule({
  declarations: [ReportingComponent],
  exports: [ReportingComponent],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule,
    CustomgridModule
  ]
})

export class ReportingModule { }
